import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isRuntimeIdentityRoute } from '../utils/runtimeIdentityRoute';

/** Select before mounting the ordinary background providers or dashboard shell. */
export default function RuntimeIdentityBoundary({ runtime, children }) {
    const { pathname, search = '', hash = '' } = useLocation();
    const standalone = isRuntimeIdentityRoute(pathname);
    const initialStandalone = useRef(standalone).current;
    const leavingStandalone = initialStandalone && !standalone;
    useEffect(() => {
        // A fresh document restores ordinary bootstrap providers after an auth
        // redirect or navigation out of a standalone diagnostic entry.
        if (leavingStandalone) window.location.replace(`${pathname}${search}${hash}`);
    }, [leavingStandalone, pathname, search, hash]);
    if (leavingStandalone) return null;
    return standalone ? runtime : children;
}
